import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { catchError, map, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  LoadUserPermissionsFail,
  LoadUserPermissionsSuccess,
  UserPermissionsActionTypes
} from './actions';
import { UserPermissionsService } from '../../services/user-permissions.service';
import { UserPermissions } from '../../types/user-permissions.types';

@Injectable()
export class UserPermissionsEffects {
  constructor(
    private actions$: Actions,
    private userPermissionsService: UserPermissionsService
  ) {}

  @Effect()
  loadUserPermissions$ = this.actions$.pipe(
    ofType(UserPermissionsActionTypes.Load),
    exhaustMap(() =>
      this.userPermissionsService.load().pipe(
        map((data: UserPermissions) => {
          return new LoadUserPermissionsSuccess(data);
        }),
        catchError((err: Error) =>
          of(new LoadUserPermissionsFail(err && err.message))
        )
      )
    )
  );
}
